import { MakeCall } from 'ha/services/apiV2/createMakeCall';

export default (makeCall: MakeCall) => (listingId: number, photoId: number) =>
  makeCall<undefined>(
    'DELETE',
    `/api/v2/listing/${listingId}/photo/${photoId}`,
  );
